import badgeImg from "coplineLogo.png";

const RecognitionItem = ({ title, name, year, description }) => {
  return (
    <div className="honor-wall-item-card">
      <div className="honor-wall-item-badge">
        <img src={badgeImg} alt="Badge" className="honor-badge-img" />
      </div>
      <h4 className="item-title">{title}</h4>
      <h5 className="item-subtitle">{name}</h5>
      <h6 className="item-year">{year}</h6>
      <p className="item-description">{description}</p>
    </div>
  );
};

export default RecognitionItem;
